import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OSIntroductionAndDesign = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Introduction to OS: Functionality of OS & OS Design Issues"
    videos={[
      "https://www.youtube.com/embed/rAMVA1QJUhU",
      "https://www.youtube.com/embed/EKW4khUAbuvI"
    ]}
    takeaways={[]}
    questions={[
      "Assume that you are designing an operating system to run multiple tasks at the same time. Identify the various design issues that need to be addressed.",
      "Considering the diverse architectures of operating systems, analyze the common structural elements they share. How do these commonalities impact the efficiency and functionality of various operating systems, and what might this suggest about the future development of OS design?"
    ]}
    exampleVideos={[]}
  />
);
}

export default OSIntroductionAndDesign;
